/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_Import_Unmatched_HintInputs */



/**
* | output |
* | --- |
* | "Add them with the usual search. An official can sponsor or create them there." |
*
* @param {Csv_Import_Unmatched_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const csv_import_unmatched_hint = /** @type {((inputs?: Csv_Import_Unmatched_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_Import_Unmatched_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajoutez-les avec la recherche habituelle. Un officiel peut les parrainer ou les créer depuis là.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Añádalos con la búsqueda habitual. Un oficial puede patrocinarlos o crearlos desde ahí.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Adicione-os pela busca de sempre. Um oficial pode patrociná-los ou criá-los por ali.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungili con la solita ricerca. Un ufficiale può sponsorizzarli o crearli da lì.")
	return /** @type {LocalizedString} */ ("Add them with the usual search. An official can sponsor or create them there.")
});